import _asyncToGenerator from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { MessageType } from "./IHubProtocol";
import { isArrayBuffer } from "./Utils";
/** @private */
export var MessageBuffer = /*#__PURE__*/function () {
  function MessageBuffer(protocol, connection, bufferSize) {
    _classCallCheck(this, MessageBuffer);
    this._bufferSize = 100000;
    this._messages = [];
    this._totalMessageCount = 0;
    this._waitForSequenceMessage = false;
    // Message IDs start at 1 and always increment by 1
    this._nextReceivingSequenceId = 1;
    this._latestReceivedSequenceId = 0;
    this._bufferedByteCount = 0;
    this._reconnectInProgress = false;
    this._protocol = protocol;
    this._connection = connection;
    this._bufferSize = bufferSize;
  }
  _createClass(MessageBuffer, [{
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(message) {
        var serializedMessage, backpressurePromise, backpressurePromiseResolver, backpressurePromiseRejector;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              serializedMessage = this._protocol.writeMessage(message);
              backpressurePromise = Promise.resolve(); // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
              if (this._isInvocationMessage(message)) {
                this._totalMessageCount++;
                backpressurePromiseResolver = function backpressurePromiseResolver() {};
                backpressurePromiseRejector = function backpressurePromiseRejector() {};
                if (isArrayBuffer(serializedMessage)) {
                  this._bufferedByteCount += serializedMessage.byteLength;
                } else {
                  this._bufferedByteCount += serializedMessage.length;
                }
                if (this._bufferedByteCount >= this._bufferSize) {
                  backpressurePromise = new Promise(function (resolve, reject) {
                    backpressurePromiseResolver = resolve;
                    backpressurePromiseRejector = reject;
                  });
                }
                this._messages.push(new BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
              }
              _context.prev = 3;
              if (this._reconnectInProgress) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return this._connection.send(serializedMessage);
            case 7:
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              this._disconnected();
            case 12:
              _context.next = 14;
              return backpressurePromise;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9]]);
      }));
      function _send(_x) {
        return _send2.apply(this, arguments);
      }
      return _send;
    }()
  }, {
    key: "_ack",
    value: function _ack(ackMessage) {
      var newestAckedMessage = -1;
      // Find index of newest message being acked
      for (var index = 0; index < this._messages.length; index++) {
        var element = this._messages[index];
        if (element._id <= ackMessage.sequenceId) {
          newestAckedMessage = index;
          if (isArrayBuffer(element._message)) {
            this._bufferedByteCount -= element._message.byteLength;
          } else {
            this._bufferedByteCount -= element._message.length;
          }
          // resolve items that have already been sent and acked
          element._resolver();
        } else if (this._bufferedByteCount < this._bufferSize) {
          // resolve items that now fall under the buffer limit but haven't been acked
          element._resolver();
        } else {
          break;
        }
      }
      if (newestAckedMessage !== -1) {
        // We're removing everything including the message pointed to, so add 1
        this._messages = this._messages.slice(newestAckedMessage + 1);
      }
    }
  }, {
    key: "_shouldProcessMessage",
    value: function _shouldProcessMessage(message) {
      if (this._waitForSequenceMessage) {
        if (message.type !== MessageType.Sequence) {
          return false;
        } else {
          this._waitForSequenceMessage = false;
          return true;
        }
      }
      // No special processing for acks, pings, etc.
      if (!this._isInvocationMessage(message)) {
        return true;
      }
      var currentId = this._nextReceivingSequenceId;
      this._nextReceivingSequenceId++;
      if (currentId <= this._latestReceivedSequenceId) {
        if (currentId === this._latestReceivedSequenceId) {
          // Should only hit this if we just reconnected and the server is sending
          // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
          this._ackTimer();
        }
        // Ignore, this is a duplicate message
        return false;
      }
      this._latestReceivedSequenceId = currentId;
      // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
      // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
      this._ackTimer();
      return true;
    }
  }, {
    key: "_resetSequence",
    value: function _resetSequence(message) {
      if (message.sequenceId > this._nextReceivingSequenceId) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
        return;
      }
      this._nextReceivingSequenceId = message.sequenceId;
    }
  }, {
    key: "_disconnected",
    value: function _disconnected() {
      this._reconnectInProgress = true;
      this._waitForSequenceMessage = true;
    }
  }, {
    key: "_resend",
    value: function () {
      var _resend2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var sequenceId, messages, _iterator, _step, element;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sequenceId = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
              _context2.next = 3;
              return this._connection.send(this._protocol.writeMessage({
                type: MessageType.Sequence,
                sequenceId: sequenceId
              }));
            case 3:
              // Get a local variable to the _messages, just in case messages are acked while resending
              // Which would slice the _messages array (which creates a new copy)
              messages = this._messages;
              _iterator = _createForOfIteratorHelper(messages);
              _context2.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context2.next = 13;
                break;
              }
              element = _step.value;
              _context2.next = 11;
              return this._connection.send(element._message);
            case 11:
              _context2.next = 7;
              break;
            case 13:
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](5);
              _iterator.e(_context2.t0);
            case 18:
              _context2.prev = 18;
              _iterator.f();
              return _context2.finish(18);
            case 21:
              this._reconnectInProgress = false;
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 15, 18, 21]]);
      }));
      function _resend() {
        return _resend2.apply(this, arguments);
      }
      return _resend;
    }()
  }, {
    key: "_dispose",
    value: function _dispose(error) {
      error !== null && error !== void 0 ? error : error = new Error("Unable to reconnect to server.");
      // Unblock backpressure if any
      var _iterator2 = _createForOfIteratorHelper(this._messages),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          element._rejector(error);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_isInvocationMessage",
    value: function _isInvocationMessage(message) {
      // There is no way to check if something implements an interface.
      // So we individually check the messages in a switch statement.
      // To make sure we don't miss any message types we rely on the compiler
      // seeing the function returns a value and it will do the
      // exhaustive check for us on the switch statement, since we don't use 'case default'
      switch (message.type) {
        case MessageType.Invocation:
        case MessageType.StreamItem:
        case MessageType.Completion:
        case MessageType.StreamInvocation:
        case MessageType.CancelInvocation:
          return true;
        case MessageType.Close:
        case MessageType.Sequence:
        case MessageType.Ping:
        case MessageType.Ack:
          return false;
      }
    }
  }, {
    key: "_ackTimer",
    value: function _ackTimer() {
      var _this = this;
      if (this._ackTimerHandle === undefined) {
        this._ackTimerHandle = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                if (_this._reconnectInProgress) {
                  _context3.next = 4;
                  break;
                }
                _context3.next = 4;
                return _this._connection.send(_this._protocol.writeMessage({
                  type: MessageType.Ack,
                  sequenceId: _this._latestReceivedSequenceId
                }));
              case 4:
                _context3.next = 8;
                break;
              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
              case 8:
                clearTimeout(_this._ackTimerHandle);
                _this._ackTimerHandle = undefined;
                // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
              case 10:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[0, 6]]);
        })), 1000);
      }
    }
  }]);
  return MessageBuffer;
}();
var BufferedItem = function BufferedItem(message, id, resolver, rejector) {
  _classCallCheck(this, BufferedItem);
  this._message = message;
  this._id = id;
  this._resolver = resolver;
  this._rejector = rejector;
};